.overlay {
    &::after {
        content: "";
        position: absolute;
        inset: 0;
        background: var(--overlay-56);
        pointer-events: none;
    }
}

.overlayGradientTop {
    composes: overlay;

    &::after {
        background: var(--overlay-gradient);
        scale: 1 -1;
    }
}

.padding {
    padding-block: var(--spacer-80);
}

.paddingExtra {
    padding-block: var(--spacer-120);
}
